import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@mui/material';
import ReloadSvg from '../../../../../public/static/icons/pegasus_reload.svg';
import { __ } from '../../../../utils/translation-service';

interface IProps {
    onClick: () => void;
}

const StyledReloadSvg = styled(ReloadSvg)`
    width: 13px;
    transform: scale3d(-1, 1, 1);
    fill: ${(props) => props.theme.colors['main4']};
    vertical-align: middle;
`;

const StyledIcon = styled(Icon)`
    font-size: 11px;
`;

export const ResetButton = (props: IProps) => {
    return (
        <StyledIcon onClick={() => props.onClick()}>
            <StyledReloadSvg /> {__('calendarReset')}
        </StyledIcon>
    );
};
